/**
 * Contenido visible del modulo: que tarjetas y que pestañas existen, con su
 * texto e icono. Es data, no JSX: los iconos se guardan como referencia al
 * componente y quien pinta decide como instanciarlos.
 *
 * Los permisos NO estan aqui. Viven en model/permisos.js, para que la regla
 * de negocio no quede escondida entre descripciones e imagenes.
 */
import PeopleIcon from "@material-ui/icons/People";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import LoopIcon from "@material-ui/icons/Loop";
import SettingsIcon from "@material-ui/icons/Settings";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EditIcon from "@material-ui/icons/Edit";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import EventIcon from "@material-ui/icons/Event";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";

import books from "../../global/imagenes/books.png";
import bookInvestigacion from "../../global/imagenes/bookInvestigacion.png";
import iconoAprendizaje from "../../global/imagenes/IconoResultadosAprendizaje.svg";

import {
  TIPO_ARIA,
  TIPO_LIBROS,
  VISTA_DETALLE,
  VISTA_GESTION,
  VISTA_GESTIONAR,
  VISTA_SOLICITANTE,
} from "./constants";

export const PROCESO_APRENDIZAJE = "procesos_aprendizaje";

/** Tarjetas de la pestaña Nuevo. Hoy solo hay un proceso. */
export const PROCESOS = [
  {
    codigo: PROCESO_APRENDIZAJE,
    nombre: "PROCESOS DE APRENDIZAJE",
    opciones: "Solicitudes",
    descripcion:
      "Solicitudes relacionadas con los procesos de aprendizaje de la biblioteca.",
    imagen: iconoAprendizaje,
    color: "#01579b",
  },
];

/** Tipos de solicitud. `codigo` es el tipo que entiende el backend. */
export const SOLICITUDES = [
  {
    codigo: TIPO_LIBROS,
    nombre: "LIBRO A TU CLASE",
    opciones: "Solicitud de material",
    descripcion:
      "Solicita el material bibliografico que necesitas para tu clase.",
    imagen: books,
    color: "#01579b",
  },
  {
    codigo: TIPO_ARIA,
    nombre: "ARIA",
    opciones: "Solicitud de material",
    descripcion: "Accede a los recursos de Aria.",
    imagen: bookInvestigacion,
    color: "#4094d7",
  },
];

/**
 * Pestañas. `vacio` es el mensaje de la bandeja sin resultados: tenerlo aqui
 * evita el switch que antes repetian las dos pantallas.
 */
export const MENU_SOLICITANTE = [
  {
    codigo: VISTA_SOLICITANTE.PROCESOS,
    label: "Procesos",
    Icono: LocationOnIcon,
    vacio: "No tienes solicitudes en proceso",
  },
  {
    codigo: VISTA_SOLICITANTE.NUEVO,
    label: "Nuevo",
    Icono: EditIcon,
    vacio: "No hay solicitudes disponibles",
  },
];

/**
 * Pestañas del modal de mas informacion. La del material cambia de nombre
 * con el tipo, y Libro a tu clase tiene ademas la de los ejemplares que
 * prepara biblioteca; por eso es una funcion y no una constante.
 */
export const menuDetalle = (tipo) => [
  {
    codigo: VISTA_DETALLE.ESTUDIANTES,
    label: "Estudiantes",
    Icono: PeopleIcon,
    vacio: "La solicitud no tiene estudiantes",
  },
  {
    codigo: VISTA_DETALLE.MATERIAL,
    label: tipo === TIPO_ARIA ? "Niveles" : "Libros",
    Icono: MenuBookIcon,
    vacio:
      tipo === TIPO_ARIA
        ? "La solicitud no tiene niveles"
        : "La solicitud no tiene libros",
  },
  ...(tipo === TIPO_LIBROS
    ? [
        {
          codigo: VISTA_DETALLE.EJEMPLARES,
          label: "Ejemplares",
          Icono: LocalLibraryIcon,
          vacio: "Biblioteca aún no ha registrado los ejemplares",
        },
      ]
    : []),
  {
    codigo: VISTA_DETALLE.HISTORIAL,
    label: "Historial",
    Icono: LoopIcon,
    vacio: "La solicitud no tiene movimientos",
  },
];

/**
 * Pestañas del modal Abrir en Gestion: los datos de la solicitud, las mismas
 * de Mas informacion y los auxiliares, que el solicitante no ve.
 */
export const menuDetalleGestion = (tipo) => {
  const [estudiantes, material, ...resto] = menuDetalle(tipo);
  const historial = resto.pop();
  return [
    {
      codigo: VISTA_DETALLE.SOLICITUD,
      label: "Solicitud",
      Icono: AssignmentIcon,
      vacio: "",
    },
    estudiantes,
    material,
    ...resto,
    {
      codigo: VISTA_DETALLE.AUXILIARES,
      label: "Auxiliares",
      Icono: SupervisorAccountIcon,
      vacio: "La solicitud no tiene auxiliares asignados",
    },
    historial,
  ];
};

/**
 * Pestañas del modal Gestionar: el cambio de estado y lo que se prepara para
 * darlo (auxiliares y, en Libro a tu clase, los ejemplares).
 */
export const menuGestionar = (tipo) => [
  { codigo: VISTA_GESTIONAR.GESTIONAR, label: "Gestionar", Icono: LoopIcon },
  { codigo: VISTA_GESTIONAR.AUXILIARES, label: "Auxiliares", Icono: SupervisorAccountIcon },
  ...(tipo === TIPO_LIBROS
    ? [{ codigo: VISTA_GESTIONAR.EJEMPLARES, label: "Ejemplares", Icono: LocalLibraryIcon }]
    : []),
];

export const MENU_GESTION = [
  {
    codigo: VISTA_GESTION.PROCESOS,
    label: "Procesos",
    Icono: ImportContactsIcon,
    vacio: "Aun no hay solicitudes",
  },
  {
    codigo: VISTA_GESTION.CALENDARIO,
    label: "Calendario",
    Icono: EventIcon,
    vacio: "No hay solicitudes en estas fechas",
  },
  {
    codigo: VISTA_GESTION.ADMINISTRAR,
    label: "Administrar",
    Icono: SettingsIcon,
    vacio: "",
  },
];

export const buscarPorCodigo = (lista, codigo) =>
  lista.find((item) => item.codigo === codigo) ?? null;
